import { combineReducers } from 'redux'
import { interface_reducer } from './interfaceReducer'

const rootReducer = combineReducers({
    interface_reducer
});

export default rootReducer
